export const UNKNOWN = "Unknown";
export const PRIMARY = "primary";
export const SECONDARY = "secondary";
